import { Pipe, PipeTransform } from '@angular/core';
import { Workout } from '../models/workout/workout';
import { FilterWorkouts } from '../views/main/views/workout/assign-workout/assign-workout.component';

@Pipe({
  name: 'filterWorkouts',
  pure: false
})

export class FilterWorkoutsPipe implements PipeTransform {
  transform(
    items: (Workout)[],
    filterObject: FilterWorkouts): (Workout)[] {
      if(filterObject.name.length) {
        items =  items.filter(workout => workout?.description?.toLowerCase().includes(filterObject.name.toLowerCase()));
      }
      if(filterObject.selectedStaffs.length) {
        items = items.filter(workout => filterObject.selectedStaffs.find(staff => staff.id === workout.idStaff));
      }
      if(filterObject.selectedObjectives.length) {
        items = items.filter(workout => filterObject.selectedObjectives.find(objective => objective.idObjetiveFamily === workout.idObjective));
      }
      return items;
  }
}
